import { render } from "./ModalSummary.vue?vue&type=template&id=2bffe6b0"
import script from "./ModalSummary.vue?vue&type=script&lang=js"
export * from "./ModalSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__